<template>
  <div
    class="preview-menu-card"
    :style="cardStyle"
    @click="$emit('click', item)"
  >
    <!-- 商品画像 -->
    <div
      class="card-image"
      :style="imageStyle"
    >
      <img
        v-if="item.imageUrl"
        :src="item.imageUrl"
        :alt="item.name"
      >
      <v-icon
        v-else
        :color="theme.primaryColor"
        size="24"
      >
        mdi-glass-cocktail
      </v-icon>
    </div>

    <!-- 商品情報 -->
    <div class="card-content">
      <div
        class="card-name"
        :style="nameStyle"
      >
        {{ item.name }}
      </div>
      <div
        class="card-price"
        :style="priceStyle"
      >
        {{ formatPrice(item.price) }}
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'

export default {
  name: 'PreviewMenuCard',

  props: {
    item: {
      type: Object,
      required: true,
    },
    theme: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const cardStyle = computed(() => ({
      backgroundColor: props.theme.cardColor,
    }))

    const imageStyle = computed(() => ({
      backgroundColor: `${props.theme.primaryColor}20`,
    }))

    const nameStyle = computed(() => ({
      color: props.theme.textColor,
    }))

    const priceStyle = computed(() => ({
      color: props.theme.primaryColor,
    }))

    const formatPrice = price => {
      return `${price.toLocaleString()}`
    }

    return {
      cardStyle,
      imageStyle,
      nameStyle,
      priceStyle,
      formatPrice,
    }
  },
}
</script>

<style scoped>
.preview-menu-card {
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.preview-menu-card:hover {
  transform: scale(1.02);
}

.card-image {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-content {
  padding: 6px;
}

.card-name {
  font-size: 10px;
  font-weight: 500;
  line-height: 1.2;
  margin-bottom: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-price {
  font-size: 11px;
  font-weight: 600;
}

.card-price::before {
  content: '\u00A5';
}
</style>
